<script>
import { authComputed } from '@state/helpers'
import Cookies from 'js-cookie'
import NavBarRoutes from './nav-bar-routes.vue'
import RepNumModal from './rep-num-modal.vue'

export default {
  components: { NavBarRoutes, RepNumModal },
  data() {
    return {
      navRoutes: [
        {
          name: 'home',
          title: 'Home',
        },
      ],
      routes: {
        biostim: {
          name: 'biostim',
          title: 'BGT',
        },
        salesEntity: {
          name: 'salesEntity',
          title: 'SalesEntity',
        },
        directory: {
          name: 'directory',
          title: 'Directory',
        },
      },
      loggedInNavRoutes: [
        {
          name: 'profile',
          title: () => 'Logged in as ' + this.currentUser.name,
        },
        {
          name: 'logout',
          title: 'Log out',
        },
      ],
      loggedOutNavRoutes: [
        {
          name: 'login',
          title: 'Log in',
        },
      ],
      repModal: false,
    }
  },
  computed: {
    ...authComputed,
    userRoles() {
      if (this.$store.getters['users/userRoles']) {
        return this.$store.getters['users/userRoles']
      } else if (Cookies.get('userRoles')) {
        return JSON.parse(Cookies.get('userRoles'))
      }
      return []
    },
    userEmail() {
      if (this.$store.getters['users/userEmail']) {
        return this.$store.getters['users/userEmail']
      } else if (Cookies.get('userEmail')) {
        return Cookies.get('userEmail')
      }
      return ''
    },
    emulation() {
      if (Cookies.get('emulation')) {
        return JSON.parse(Cookies.get('emulation'))
      }
      return false
    },
    emailLink() {
      if(!this.userEmail || !this.userEmail.toLowerCase().includes('@orthofix')) {
        return undefined;
      }
      if(this.userRoles.some(role => role.includes('Office365_License_E1_Group_Orthofix') || role.includes('Office365_License_E3_Group_Orthofix') || role.includes('Office365_License_E1_Group') || role.includes('Office365_License_E3_Group'))) {
        return 'https://outlook.office.com/mail';
      }
      return 'https://email.orthofix.com/owa';
    }
  },
  mounted() {
    this.addNavRoutes()
  },
  methods: {
    handleSubmit() {
      this.$store.commit('users/SET_REPNUM', this.repNum)
      this.$router.go()
    },
    closeModal() {
      this.repModal = false
    },
    addNavRoutes() {
      if (
        this.userRoles.some(g => g.includes('BI PORTAL POWER USER')) ||
        this.emulation === true
      ) {
        this.navRoutes.push(this.routes.biostim)
        this.navRoutes.push(this.routes.salesEntity)
        this.navRoutes.push(this.routes.directory)
      } else {
        if (this.userRoles.some(g => g.includes('BI PORTAL BIOSTIM SALES ENTITY'))) {
          this.navRoutes.push(this.routes.biostim)
        }
        if (this.userRoles.some(g => g.includes('BI PORTAL ALL SBU SALES ENTITY'))) {
          this.navRoutes.push(this.routes.salesEntity)
        }
      }
    },
  },
}
</script>

<template>
  <header
    style="background-color: #006fa9"
    class="d-flex justify-content-between row w-100 m-0"
  >
    <div
      style="padding: 0.7rem; padding-left: 1rem"
      class="d-flex justify-content-between"
    >
      <div @click="$router.push('/home')">
        <svg
          style="width: 192px"
          xmlns="http://www.w3.org/2000/svg"
          xmlns:xlink="http://www.w3.org/1999/xlink"
          viewBox="0 0 223 36"
        >
          <defs>
            <polygon
              id="white-a"
              points=".994 .867 29.896 .867 29.896 35 .994 35"
            ></polygon>
            <polygon
              id="white-c"
              points="0 35 222.84 35 222.84 .867 0 .867"
            ></polygon>
          </defs>
          <g fill="none" fill-rule="evenodd">
            <g transform="translate(0 .134)">
              <path
                fill="#FFF"
                d="M19.6531,29.1126 C16.5761,27.2296 13.8981,23.9736 12.3761,19.8276 C10.8481,15.6666 10.7821,11.4166 11.9101,7.9536 L0.7731,12.1336 C-0.3549,15.5976 -0.2889,19.8466 1.2391,24.0076 C2.7611,28.1536 5.4391,31.4096 8.5161,33.2926 L19.6531,29.1126 Z"
              ></path>
              <g transform="translate(4)">
                <mask id="white-b" fill="#fff">
                  <use xlink:href="#white-a"></use>
                </mask>
                <path
                  fill="#FFF"
                  d="M22.9114,30.8196 C29.0624,28.5106 31.6344,20.0656 28.6574,11.9566 C25.6804,3.8466 18.2814,-0.8554 12.1304,1.4536 L0.9944,5.6336 C7.1444,3.3246 14.5444,8.0276 17.5214,16.1366 C20.4984,24.2456 17.9254,32.6906 11.7744,34.9996 L22.9114,30.8196 Z"
                  mask="url(#white-b)"
                ></path>
              </g>
            </g>
            <g transform="translate(0 .134)">
              <path
                fill="#FFF"
                d="M219.8821 9.5071L219.8821 10.4491 220.3311 10.4491C220.8171 10.4491 221.0451 10.3281 221.0451 9.9961 221.0451 9.6481 220.8171 9.5071 220.3171 9.5071L219.8821 9.5071zM221.5911 9.9401C221.5911 10.3431 221.3591 10.6211 220.9471 10.7081L221.5761 12.0001 220.9821 12.0001 220.4071 10.7911 219.8821 10.7911 219.8821 12.0001 219.3471 12.0001 219.3471 9.1591 220.4161 9.1591C221.2011 9.1591 221.5911 9.4271 221.5911 9.9401zM221.8981 9.0981C221.4811 8.6731 220.9471 8.4501 220.3561 8.4501 219.7721 8.4501 219.2381 8.6681 218.8421 9.0671 218.4201 9.5011 218.1861 10.0581 218.1861 10.6301 218.1861 11.1991 218.4141 11.7391 218.8191 12.1521 219.2321 12.5721 219.7761 12.8011 220.3311 12.8011 220.9221 12.8011 221.4541 12.5801 221.8841 12.1611 222.2891 11.7651 222.5131 11.2271 222.5131 10.6491 222.5131 10.0471 222.2981 9.5011 221.8981 9.0981zM222.1251 8.8671C222.5811 9.3351 222.8391 9.9601 222.8391 10.6301 222.8391 11.3191 222.5891 11.9301 222.1191 12.3901 221.6281 12.8701 220.9971 13.1341 220.3481 13.1341 219.6811 13.1341 219.0661 12.8701 218.5821 12.3841 218.1191 11.9051 217.8571 11.2931 217.8571 10.6301 217.8571 9.9661 218.1291 9.3261 218.6131 8.8341 219.0721 8.3671 219.6751 8.1231 220.3481 8.1231 221.0221 8.1231 221.6481 8.3801 222.1251 8.8671zM72.9802 16.095C72.9832 16.123 78.7202 16.112 78.7202 16.112L79.7332 16.112C83.3592 16.112 84.6262 15.571 84.6262 13.74 84.6262 12.634 84.7002 11.423 79.7332 11.423L78.7202 11.423C73.0242 11.615 73.0252 15.613 72.9802 16.095M78.7202 8.096L81.0042 8.096C87.0912 8.096 90.1332 9.67 90.1332 13.688 90.1332 16.267 88.4662 18.277 84.9162 18.872L91.3302 26.629 85.2042 26.629 79.4462 19.386 72.9812 19.386 72.9642 26.623 67.4282 26.617C67.4282 26.617 67.4492 17.514 67.4492 17.505 67.6642 13.846 67.3282 8.039 78.7202 8.096M52.8689 23.8504C58.0159 23.8504 59.9729 21.2484 59.9729 17.4104 59.9729 14.7014 59.2119 10.9424 52.8689 10.9424 48.0519 10.9424 45.8049 13.3634 45.8049 17.3334 45.8049 20.9134 47.4349 23.8504 52.8689 23.8504M65.9479 17.3874C65.9479 23.1064 62.7249 27.0214 52.9079 27.0214 43.9219 27.0214 39.8639 23.7774 39.8639 17.3334 39.8639 9.8834 45.5529 7.7464 52.8339 7.7464 59.7899 7.7464 65.9479 9.5204 65.9479 17.3874"
              ></path>
              <polygon
                fill="#FFF"
                points="98.977 26.638 98.977 11.379 90.647 11.379 90.647 8.161 113.07 8.161 113.07 11.379 104.67 11.379 104.67 26.638"
              ></polygon>
              <polygon
                fill="#FFF"
                points="114.615 8.105 120.086 8.105 120.086 15.605 130.124 15.605 130.124 8.105 135.557 8.105 135.557 26.638 130.124 26.638 130.124 18.881 120.086 18.881 120.086 26.638 114.615 26.638"
              ></polygon>
              <path
                fill="#FFF"
                d="M150.0022 23.8504C155.1462 23.8504 157.1022 21.2484 157.1022 17.4104 157.1022 14.7014 156.3432 10.9424 150.0022 10.9424 145.1832 10.9424 142.9372 13.3634 142.9372 17.3334 142.9372 20.9134 144.5682 23.8504 150.0022 23.8504M163.0832 17.3874C163.0832 23.1064 159.8562 27.0214 150.0402 27.0214 141.0492 27.0214 136.9932 23.7774 136.9932 17.3334 136.9932 9.8834 142.6822 7.7464 149.9652 7.7464 156.9232 7.7464 163.0832 9.5204 163.0832 17.3874M164.5496 26.638L164.5496 18.131C164.5496 8.982 169.1126 8.105 177.3766 8.105L185.7066 8.105 185.7066 11.328 176.8676 11.328C172.5566 11.328 170.3846 12.333 170.0906 15.862L182.7016 15.862 182.7016 19.033 170.0906 19.033 170.0906 26.638 164.5496 26.638z"
              ></path>
              <mask id="white-d" fill="#fff">
                <use xlink:href="#white-c"></use>
              </mask>
              <polygon
                fill="#FFF"
                points="187.215 26.638 192.942 26.638 192.942 8.105 187.215 8.105"
                mask="url(#white-d)"
              ></polygon>
              <polygon
                fill="#FFF"
                points="194.109 26.638 203.169 17.388 194.4 8.105 200.777 8.105 206.136 14.008 211.463 8.105 217.766 8.105 209.396 17.126 218.38 26.638 211.825 26.638 206.356 20.194 200.558 26.638"
                mask="url(#white-d)"
              ></polygon>
            </g>
          </g>
        </svg>
      </div>

      <div class="d-flex">
        <div class="d-flex">
          <a
            id="tooltip-orthofix"
            href="https://www.orthofix.com/"
            target="_blank"
            class="px-1"
            ><img
              src="@assets/images/ortho.png"
              alt=""
              class="ext_link"
              style="padding: 3px"
          /></a>
          <b-tooltip target="tooltip-orthofix" triggers="hover">
            Orthofix
          </b-tooltip>
        </div>
        <div v-if="emailLink" class="d-flex">
          <a
            id="tooltip-mail"
            :href="emailLink"
            target="_blank"
            class="px-1"
          >
            <img class="ext_link" src="@assets/images/email-small.png" alt="" />
          </a>
          <b-tooltip target="tooltip-mail" triggers="hover"> Mail </b-tooltip>
        </div>
        <div class="d-flex">
          <a
            id="tooltip-literature"
            href="https://orders.four51ordercloud.com/SeaSpine/catalog"
            target="_blank"
            class="px-1"
            >
              <img src="@assets/images/POD-icon.png" alt="" class="ext_link" />
          </a>
          <b-tooltip target="tooltip-literature" triggers="hover">
            Literature
          </b-tooltip>
        </div>
        <div class="d-flex">
          <a
            id="tooltip-orientation"
            href="http://orthonet/portal/orientation/Pages/default.aspx"
            target="_blank"
            class="px-1"
            ><img
              src="@assets/images/Orientation_Icon_small.png"
              alt=""
              class="ext_link"
          /></a>
          <b-tooltip target="tooltip-orientation" triggers="hover">
            Orientation
          </b-tooltip>
        </div>
        <div class="d-flex">
          <a
            id="tooltip-workday"
            href="https://www.myworkday.com/orthofix/d/home.htmld"
            target="_blank"
            class="px-1"
            ><img
              src="@assets/images/Workday-white-small.png"
              alt=""
              class="ext_link"
              style="padding: 1px;"
          /></a>
          <b-tooltip target="tooltip-workday" triggers="hover">
            Workday
          </b-tooltip>
        </div>
        <div class="d-flex">
          <a
            id="tooltip-goLearn"
            href="https://golearn.orthofix.com/learn"
            target="_blank"
            class="px-1"
            ><img
              src="@assets/images/gl2.png"
              alt=""
              class="ext_link"
              style="
                width: 37px;
                object-fit: contain;
                padding: 4px;
                filter: contrast(2);
              "
          /></a>
          <b-tooltip target="tooltip-goLearn" triggers="hover">
            go Learn
          </b-tooltip>
        </div>
        <div v-if="emulation">
          <b-dropdown
            id="dropdown"
            toggle-class="dropdownToggle"
            right
            style="transform: scale(0.9)"
            class="px-1"
          >
            <!-- <b-dropdown
            size="lg"
            variant="link"
            right
            toggle-class="text-decoration-none"
            no-caret
          >
            <template #button-content>
              &#x1f50d;<span class="sr-only">Search</span>
            </template> -->
            <b-dropdown-item @click="repModal = true"
              >Enter Rep Number</b-dropdown-item
            >
          </b-dropdown>
          <b-tooltip target="dropdown" triggers="hover"> Options </b-tooltip>
          <RepNumModal v-if="repModal" @close="closeModal"></RepNumModal>
        </div>
      </div>
    </div>
    <div
      style="background-color: #0061a5; border-bottom: 4px solid #005896"
      class="col-12 text-white d-flex align-self-center"
    >
      <ul :class="$style.container" class="m-0">
        <NavBarRoutes :routes="navRoutes" />
        <!-- <NavBarRoutes v-if="loggedIn" :routes="loggedInNavRoutes" />
        <NavBarRoutes v-else :routes="loggedOutNavRoutes" /> -->
      </ul>
    </div>
  </header>
</template>

<style lang="scss" module>
@import '@design';

.container {
  padding: 0;
  text-align: center;
  list-style-type: none;

  > li {
    display: inline-block;
  }
}
</style>

<style lang="scss" scoped>
::v-deep .dropdownToggle,
::v-deep .dropdownToggle:hover,
::v-deep .dropdownToggle:focus,
::v-deep .show > .btn-secondary.dropdown-toggle {
  // box-shadow: 0px 0px 0px 1px #244f67;
  background-color: transparent;
  border: 1px solid white;
  border-radius: 18px;
}

.ext_link {
  border-radius: 30px;
  height: 38px;
  border: 1px solid white;
  transform: scale(0.95);
}
</style>
